var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"spinner-container",staticClass:"spinner-container"},[_c('div',{ref:"custom-spinner",staticClass:"custom-spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }